import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PACKAGING_TYPES } from '../models/work-order.constants'
import { Router } from '@angular/router';

@Component({
  selector: 'app-freightmancer-jr',
  templateUrl: './freightmancer-jr.component.html',
  styleUrls: ['./freightmancer-jr.component.scss'],
  
})
export class FreightmancerJrComponent implements OnInit {

  isDropTrailerEntry(): boolean {
    return this.router.url.includes('drop_trailer_entry');
  }

  
  step = 1;
  totalSteps = 3;
  customers: any[] = []; // fetched from API
  consignees: any[] = []; // fetched from API
  shippers: any[] = []; // fetched from API
  carriers: any[] = []; // fetched from API
  selectedCustomer: any;
  selectedCustomerAddressUuid: string | null = null;
  selectedShipper: any;
  selectedShipperAddressUuid: string | null = null;
  selectedConsignee: any;
  selectedConsigneeAddressUuid: string | null = null;
  selectedCarrier: any;
  selectedCarrierAddressUuid: string | null = null;
  customerCarrierForm: FormGroup;
  shipperConsigneeForm: FormGroup;
  workOrderDetailsForm: FormGroup;

  orderTypes: any[] = [
    { name: 'USA Domestic', value: 1 },
    { name: 'Canada Domestic', value: 2 },
    { name: 'USA Crossborder', value: 3 },
    { name: 'Canada Crossborder', value: 4 },
  ];
  
  customBrokers: any[] = []; // fetched from API
  packagingTypes = Object.keys(PACKAGING_TYPES);
  
  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.customerCarrierForm = this.formBuilder.group({
      selectedCustomer: [null, Validators.required],
      selectedCustomerAddressUuid: [{value: null, disabled: true}, Validators.required],
      selectedCarrier: [null, Validators.required],
      selectedCarrierAddressUuid: [null, Validators.required],
    });

    this.shipperConsigneeForm = this.formBuilder.group({
      selectedShipper: [null, Validators.required],
      selectedShipperAddressUuid: [null, Validators.required],
      selectedConsignee: [null, Validators.required],
      selectedConsigneeAddressUuid: [null, Validators.required],
      pickUpReference: ['', Validators.required],
      pickUpDate: ['', Validators.required],
      pickUpTime: ['', Validators.required],
      pickUpNote: [''],
      loadPieces: ['', Validators.required],
      deliveryReference: ['', Validators.required],
      deliveryDate: ['', Validators.required],
      deliveryTime: ['', Validators.required],
    });

    this.workOrderDetailsForm = this.formBuilder.group({
      orderType: [''],
      customBroker: [''],
      packagingType: this.buildPackagingTypes(),
      trailerNumber: [''],
      sealNumber: [''],
      pickNumber: ['']
    });
  }

  ngOnInit() {
    this.fetchDropdownData();
  }

  fetchDropdownData() {
    this.http
      .get<any>('/api/work_orders/drop_trailer_wizard.php')
      .subscribe((response) => {
        this.customers = response?.drop_trailer_customers ?? [];
        this.consignees = response?.drop_trailer_consignees ?? [];
        this.shippers = response?.drop_trailer_shippers ?? [];
        this.carriers = response?.drop_trailer_carries ?? [];
        this.customBrokers = response?.custom_brokers ?? [];
      });
  }

  onCustomerSelected(customer: any) {
    this.selectedCustomer = customer;
    this.selectedCustomerAddressUuid = null;
    const customerAddressControl = this.customerCarrierForm.get('selectedCustomerAddressUuid');
    customerAddressControl?.enable();
    customerAddressControl?.markAsTouched();
  }

  onShipperSelected(shipper: any) {
    this.selectedShipper = shipper;
    this.selectedShipperAddressUuid = null;
    const shipperAddressControl = this.shipperConsigneeForm.get('selectedShipperAddressUuid');
    shipperAddressControl?.enable();
    shipperAddressControl?.markAsTouched();
  }

  onConsigneeSelected(consignee: any) {
    this.selectedConsignee = consignee;
    this.selectedConsigneeAddressUuid = null;
    const consigeeAddressControl = this.shipperConsigneeForm.get('selectedConsigneeAddressUuid');
    consigeeAddressControl?.enable();
    consigeeAddressControl?.markAsTouched();
  }

  onCarrierSelected(carrier: any) {
    this.selectedCarrier = carrier;
    this.selectedCarrierAddressUuid = null;
    const carrierAddressControl = this.customerCarrierForm.get('selectedCarrierAddressUuid');
    carrierAddressControl?.enable();
    carrierAddressControl?.markAsTouched();
  }

  buildPackagingTypes() {
    const arr = this.packagingTypes.map(() => {
      return this.formBuilder.control(false);
    });
    return this.formBuilder.array(arr);
  }
  nextStep() {
    if (this.step < this.totalSteps) {
      this.step++;
    }
  }

  prevStep() {
    if (this.step > 1) {
      this.step--;
    }
  }
}